<wms-vcs-pull-dialog [vcsAction]="'pull'" id="pullChangesModal"></wms-vcs-pull-dialog>

<!-- Push Changes Modal -->
<wms-vcs-push-dialog></wms-vcs-push-dialog>

<!-- View Changes Modal -->
<wms-vcs-view-dialog></wms-vcs-view-dialog>

<!--Commit History Modal  -->
<wms-vcs-commit-history-dialog></wms-vcs-commit-history-dialog>

<!-- Push To External VCS Modal -->
<wms-vcs-push-external-repo-dialog></wms-vcs-push-external-repo-dialog>

<!-- Diff Editor Modal  -->
<wms-wms-vcs-compare-file-diff-dialog></wms-wms-vcs-compare-file-diff-dialog>

<!-- Project Changes Dialog -->
<!--<wms-vcs-project-changes-dialog></wms-vcs-project-changes-dialog>-->

<wms-vcs-create-mr-dialog></wms-vcs-create-mr-dialog>
